import { TLAreaType, TLFunctionType } from "./area-function";

export const CLAIRE_CONFIG_DEFAULT_AREAS: any = {
    [TLAreaType.LANGUAGE]: {
        icon: 'sms',
        title: 'AREA_NAME.LANGUAGE',
        description: 'AREA_DESCRIPTION.LANGUAGE',
        enabled: true
    },
    [TLAreaType.MENTAL_SCHEME]: {
        icon: 'cognition',
        title: 'AREA_NAME.MENTAL_SCHEME',
        description: 'AREA_DESCRIPTION.MENTAL_SCHEME',
        enabled: true
    },
    [TLAreaType.PRIOR_KNOWLEDGE]: {
        icon: 'personal_bag',
        title: 'AREA_NAME.PRIOR_KNOWLEDGE',
        description: 'AREA_DESCRIPTION.PRIOR_KNOWLEDGE',
        enabled: true
    },
    [TLAreaType.VERIFY_KNOWLEDGE]: {
        icon: 'list_alt_check',
        title: 'AREA_NAME.VERIFY_KNOWLEDGE',
        description: 'AREA_DESCRIPTION.VERIFY_KNOWLEDGE',
        enabled: true
    }
};

export const CLAIRE_CONFIG_DEFAULT_FUNCTIONS: any = {
    [TLFunctionType.DICTIONARY]: {
        icon: 'dictionary',
        title: 'AI_FUNCTION.DICTIONARY',
        description: 'AI_FUNCTION_DESCRIPTION.DICTIONARY',
        enabled: true,
        area: TLAreaType.LANGUAGE
    },
    [TLFunctionType.SIMPLIFY]: {
        icon: 'text_compare',
        title: 'AI_FUNCTION.SIMPLIFY',
        description: 'AI_FUNCTION_DESCRIPTION.SIMPLIFY',
        enabled: true,
        area: TLAreaType.LANGUAGE
    },
    [TLFunctionType.OUTLINE]: {
        icon: 'tenancy',
        title: 'AI_FUNCTION.OUTLINE',
        description: 'AI_FUNCTION_DESCRIPTION.OUTLINE',
        enabled: true,
        area: TLAreaType.MENTAL_SCHEME
    },
    [TLFunctionType.SUMMARY]: {
        icon: 'storage',
        title: 'AI_FUNCTION.SUMMARY',
        description: 'AI_FUNCTION_DESCRIPTION.SUMMARY',
        enabled: true,
        area: TLAreaType.MENTAL_SCHEME
    },
    [TLFunctionType.TIMELINE]: {
        icon: 'calendar_clock',
        title: 'AI_FUNCTION.TIMELINE',
        description: 'AI_FUNCTION_DESCRIPTION.TIMELINE',
        enabled: true,
        area: TLAreaType.MENTAL_SCHEME
    },
    [TLFunctionType.CAUSE_EFFECT]: {
        icon: 'signpost',
        title: 'AI_FUNCTION.CAUSE_EFFECT',
        description: 'AI_FUNCTION_DESCRIPTION.CAUSE_EFFECT',
        enabled: true,
        area: TLAreaType.MENTAL_SCHEME
    },
    [TLFunctionType.WHO_WHAT_WHERE_WHEN]: {
        icon: 'indeterminate_question_box',
        title: 'AI_FUNCTION.WHO_WHAT_WHERE_WHEN',
        description: 'AI_FUNCTION_DESCRIPTION.WHO_WHAT_WHERE_WHEN',
        enabled: true,
        area: TLAreaType.MENTAL_SCHEME
    },
    [TLFunctionType.BEFORE_READ]: {
        icon: 'wb_incandescent',
        title: 'AI_FUNCTION.BEFORE_READ',
        description: 'AI_FUNCTION_DESCRIPTION.BEFORE_READ',
        enabled: true,
        area: TLAreaType.PRIOR_KNOWLEDGE
    },
    [TLFunctionType.BASIS]: {
        icon: 'brick',
        title: 'AI_FUNCTION.BASIS',
        description: 'AI_FUNCTION_DESCRIPTION.BASIS',
        enabled: true,
        area: TLAreaType.PRIOR_KNOWLEDGE
    },
    [TLFunctionType.EXERCISES]: {
        icon: 'exercise',
        title: 'AI_FUNCTION.EXERCISES',
        description: 'AI_FUNCTION_DESCRIPTION.EXERCISES',
        enabled: true,
        area: TLAreaType.VERIFY_KNOWLEDGE
    },
    [TLFunctionType.QUESTIONS]: {
        icon: 'psychology_alt',
        title: 'AI_FUNCTION.QUESTIONS',
        description: 'AI_FUNCTION_DESCRIPTION.QUESTIONS',
        enabled: true,
        area: TLAreaType.VERIFY_KNOWLEDGE
    },
    [TLFunctionType.TUTOR_QUIZ]: {
        icon: 'conversation',
        title: 'AI_FUNCTION.TUTOR_QUIZ',
        description: 'AI_FUNCTION_DESCRIPTION.TUTOR_QUIZ',
        enabled: false,
        area: TLAreaType.VERIFY_KNOWLEDGE
    }
};
